import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BehaviorSubject,
  map,
  Observable,
  ReplaySubject,
  take,
  tap,
} from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
  private _httpClient = inject(HttpClient);
  private _user: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _notifications: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  private _backendUrl = environment.backendUrl;

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  get notifications$() {
    return this._notifications.asObservable();
  }
  set notifications(notifications: any) {
    this._notifications.next(notifications);
  }
  /**
   * Setter & getter for user
   *
   * @param value
   */
  set user(value: any) {
    // Store the value
    this._user.next(value);
  }

  get user$(): Observable<any> {
    return this._user.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Constructor
  // -----------------------------------------------------------------------------------------------------

  getNotifications(page: number = 1, limit: number = 10): Observable<any> {
    return this._httpClient
      .get<any>(`${this._backendUrl}client/notifications`, {
        params: {
          page,
          limit,
        },
      })
      .pipe(
        tap((response: any) => {
          const notificationsx = this._notifications.getValue();

          this._notifications.next([
            ...notificationsx,
            ...response.payload.notifications,
          ]);
        })
      );
  }

  clearNotifications(): void {
    this._notifications.next([]);
  }

  // Marca como leída
  markNotificationAsRead(id: string) {
    return this._httpClient
      .put(`${this._backendUrl}client/notifications/${id}`, { read: true })
      .pipe(
        tap(() => {
          // Actualiza la notificación en el BehaviorSubject
          const notifications = this._notifications.getValue();
          const updatedNotifications = notifications.map(
            (notification: any) => {
              if (notification._id === id) {
                return { ...notification, read: true };
              }
              return notification;
            }
          );
          this._notifications.next(updatedNotifications);
        })
      );
  }

  // Elimina una notificación
  deleteNotification(id: string) {
    return this._httpClient
      .delete(`${this._backendUrl}client/notifications/${id}`)
      .pipe(
        tap(() => {
          // Actualiza la lista de notificaciones en el BehaviorSubject
          const notifications = this._notifications.getValue();
          const updatedNotifications = notifications.filter(
            (notification: any) => notification._id !== id
          );
          this._notifications.next(updatedNotifications);
        })
      );
  }
}
